(function () {
  if (window.__asInit) return;
  window.__asInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('as-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 }) : null;

  function initReveals(root) {
    root.querySelectorAll('.as-reveal, .as-pasos, .as-tabla').forEach(function (el) {
      if (el.dataset.asReveal) return; el.dataset.asReveal = '1';
      if (!io || reduce) { el.classList.add('as-visible'); return; }
      io.observe(el);
    });
  }

  function initHero(root) {
    root.querySelectorAll('.as-hero').forEach(function (hero) {
      if (hero.dataset.asInit) return; hero.dataset.asInit = '1';
      requestAnimationFrame(function () { hero.classList.add('as-listo'); });
      if (reduce || !finePointer || hero.dataset.foco === 'false') return;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--as-x', ((ev.clientX - r.left) / r.width * 100) + '%');
        hero.style.setProperty('--as-y', ((ev.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-as-hotspots]').forEach(function (box) {
      if (box.dataset.asInit) return; box.dataset.asInit = '1';
      var puntos = box.querySelectorAll('.as-punto');
      var items = box.querySelectorAll('.as-hot-item');
      function activar(i) {
        puntos.forEach(function (p, k) { p.classList.toggle('as-activo', k === i); p.setAttribute('aria-pressed', k === i); });
        items.forEach(function (it, k) { it.classList.toggle('as-activo', k === i); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { activar(i); });
        p.addEventListener('mouseenter', function () { activar(i); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { activar(i); });
        it.addEventListener('mouseenter', function () { activar(i); });
      });
      activar(0);
    });
  }

  function initAntesDespues(root) {
    root.querySelectorAll('.as-ad').forEach(function (ad) {
      if (ad.dataset.asInit) return; ad.dataset.asInit = '1';
      var asa = ad.querySelector('.as-ad-asa');
      var pos = parseFloat(ad.dataset.inicio || 50);
      function set(p) { pos = Math.max(0, Math.min(100, p)); ad.style.setProperty('--as-pos', pos + '%'); asa.setAttribute('aria-valuenow', Math.round(pos)); }
      function desdeEvento(ev) { var r = ad.getBoundingClientRect(); set((ev.clientX - r.left) / r.width * 100); }
      var arrastrando = false;
      ad.addEventListener('pointerdown', function (ev) { arrastrando = true; ad.setPointerCapture(ev.pointerId); desdeEvento(ev); });
      ad.addEventListener('pointermove', function (ev) { if (arrastrando) desdeEvento(ev); });
      ad.addEventListener('pointerup', function () { arrastrando = false; });
      ad.addEventListener('pointercancel', function () { arrastrando = false; });
      asa.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowLeft') { set(pos - 5); ev.preventDefault(); }
        if (ev.key === 'ArrowRight') { set(pos + 5); ev.preventDefault(); }
      });
      set(pos);
    });
  }

  function initFaq(root) {
    root.querySelectorAll('.as-faq-item').forEach(function (item) {
      if (item.dataset.asInit) return; item.dataset.asInit = '1';
      var btn = item.querySelector('.as-faq-q');
      btn.addEventListener('click', function () {
        var abierto = item.classList.toggle('as-abierto');
        btn.setAttribute('aria-expanded', abierto);
      });
    });
  }

  function initIman(root) {
    if (reduce || !finePointer) return;
    root.querySelectorAll('.as-iman').forEach(function (btn) {
      if (btn.dataset.asInit) return; btn.dataset.asInit = '1';
      var zona = btn.parentElement;
      zona.addEventListener('pointermove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2), dy = ev.clientY - (r.top + r.height / 2);
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < 160) btn.style.transform = 'translate(' + (dx * 0.06) + 'px,' + (dy * 0.1) + 'px)';
        else btn.style.transform = '';
      });
      zona.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  function initGaleria(root) {
    root.querySelectorAll('[data-as-galeria]').forEach(function (g) {
      if (g.dataset.asInit) return; g.dataset.asInit = '1';
      var principal = g.querySelector('.as-galeria-principal img');
      g.querySelectorAll('.as-miniaturas button').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.as-miniaturas button').forEach(function (x) { x.classList.remove('as-activo'); });
          b.classList.add('as-activo');
          principal.src = b.dataset.src;
          principal.alt = b.dataset.alt || '';
        });
      });
    });
  }

  function initVariantes(root) {
    root.querySelectorAll('[data-as-producto]').forEach(function (box) {
      if (box.dataset.asInit) return; box.dataset.asInit = '1';
      var datos = box.querySelector('script[type="application/json"]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var idInput = box.querySelector('input[name="id"]');
      var precio = box.querySelector('[data-as-precio]');
      var tachado = box.querySelector('[data-as-tachado]');
      var boton = box.querySelector('[data-as-boton]');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';
      var formato = box.dataset.formato || '{{amount}}';
      function money(c) { return formato.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2).replace('.', ',')); }
      box.querySelectorAll('.as-variante input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          box.querySelectorAll('.as-variante fieldset').forEach(function (fs) {
            var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) return;
          idInput.value = v.id;
          if (precio) precio.textContent = money(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
          if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
        });
      });
    });
  }

  function initTodo(ev) {
    var root = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initReveals(root); initHero(root); initHotspots(root); initAntesDespues(root);
    initFaq(root); initIman(root); initGaleria(root); initVariantes(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
